import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import EditProfile from '../../components/DashBoard/Profile/EditProfile'
import Meta from '../../components/Helmet/Meta'
import SideBarComponents from '../../components/SideBar/SideBarComponents'
import './dashboard.css'

const ProfileScreen = () => {
    return (
        <div  className="main"  fluid>
            <Meta
                title=" | Admin Profile"
            />
            <Container fluid>
                <Row>
                    <Col md={3}>
                        <h4>   </h4>
                    </Col>
                    <Col md={9}>
                        <h4 > Modifier Profil de l'utilisateur </h4>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <SideBarComponents />
                    </Col>
                    <Col md={9}>
                        <EditProfile />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default ProfileScreen
